import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { search } from "../lib/api";
import TrackCard from "../components/TrackCard";

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [data, setData] = useState({ tracks: [], articles: [], reciters: [] });

  useEffect(() => {
    if (q) search(q).then(setData).catch(() => {});
  }, [q]);

  return (
    <div data-testid="search-page" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
      <div className="overline text-[#B79C7B] mb-3">Results</div>
      <h1 className="font-serif text-4xl text-ivory">Search: <span className="italic text-[#B79C7B]">"{q}"</span></h1>

      <section className="mt-12">
        <h2 className="font-serif text-2xl text-ivory mb-6">Tracks ({data.tracks.length})</h2>
        {data.tracks.length === 0 ? <p className="text-[#71717A]">No tracks found.</p> : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-5">
            {data.tracks.map((t) => <TrackCard key={t.id} track={t} />)}
          </div>
        )}
      </section>

      <section className="mt-12">
        <h2 className="font-serif text-2xl text-ivory mb-6">Reciters ({data.reciters.length})</h2>
        <div className="flex flex-wrap gap-3">
          {data.reciters.map((r) => (
            <span key={r.id} className="px-4 py-2 border border-[#2A2A2D] text-sm text-[#F4F0EA]" data-testid={`search-reciter-${r.id}`}>{r.name}</span>
          ))}
          {data.reciters.length === 0 && <p className="text-[#71717A]">No reciters found.</p>}
        </div>
      </section>

      <section className="mt-12">
        <h2 className="font-serif text-2xl text-ivory mb-6">Articles ({data.articles.length})</h2>
        <div className="space-y-3">
          {data.articles.map((a) => (
            <Link key={a.id} to={`/news/${a.slug}`} className="block p-4 border border-[#2A2A2D] hover:border-[#B79C7B]/60 transition-colors" data-testid={`search-article-${a.slug}`}>
              <div className="font-serif text-xl text-ivory">{a.title}</div>
              <p className="text-sm text-[#A1A1AA] mt-1 line-clamp-2">{a.excerpt}</p>
            </Link>
          ))}
          {data.articles.length === 0 && <p className="text-[#71717A]">No articles found.</p>}
        </div>
      </section>
    </div>
  );
}
